/* eslint-disable import/prefer-default-export */
export const GENRE_OPTIONS = [
  { label: 'Electronic', value: 'electronic' },
  { label: 'Folk/Country', value: 'folk' },
  { label: 'Jazz', value: 'jazz' },
  { label: 'Pop/R&B', value: 'pop' },
  { label: 'Rock', value: 'rock' },
  { label: 'Experimental', value: 'experimental' },
  { label: 'Global', value: 'global' },
  { label: 'Rap/Hip-Hop', value: 'rap' },
  { label: 'Latin', value: 'latin' },
  { label: 'Indie', value: 'indie' },
  { label: 'Flamenco', value: 'flamenco' },
  { label: 'Urban', value: 'urban' },
  { label: 'Punk', value: 'punk' },
];
